export default "__VITE_ASSET__CRAoKQWs__"